import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import style from 'ember-style-modifier';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface ContentWithSidebarSignature {
  Args: {
    hasSpacing?: boolean;
    sidebarPosition?: 'left' | 'right';
    stickySidebarOffset?: string;
  };
  Blocks: {
    content: [];
    sidebar: [];
  };
  Element: HTMLDivElement;
}

export default class UiContentWithSidebarComponent extends Component<ContentWithSidebarSignature> {
  // Getter and setter
  get sidebarPosition() {
    return this.args.sidebarPosition ?? 'right';
  }

  get hasSpacing() {
    return this.args.hasSpacing ?? false;
  }

  get stickySidebarOffset() {
    return this.args.stickySidebarOffset ?? '0px';
  }

  // Template
  <template>
    <div
      class={{bem
        (hash sidebar-position=this.sidebarPosition has-spacing=this.hasSpacing)
      }}
      {{style top=this.stickySidebarOffset}}
      ...attributes
    >
      <div class={{bem 'content'}}>
        {{yield to='content'}}
      </div>
      <div class={{bem 'aside'}}>
        {{yield to='sidebar'}}
      </div>
    </div>
  </template>
}
